import { CheckCircle } from "lucide-react";
import React from "react";
import { motion } from "framer-motion";
import { slideLeft } from "../../animations/variants";
import { Compass, LineChart, Landmark } from "lucide-react";
import {
  consultsData,
  heroConsultingText,
  leadershipCTA,
} from "i18n/consulting";
import { useSelector } from "react-redux";

const ListConsults = () => {
  const lang = useSelector((state) => state.language.lang);
  const consults = consultsData[lang];
  const icons = [Compass, LineChart];
  const cta = leadershipCTA[lang];
  const t = heroConsultingText[lang];

  return (
    <section className="py-20 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto my-16"
        >
          <h2 className="text-4xl md:text-6xl font-[Crimson] text-reddark leading-tight mb-3 font-normal">
            {t.main}
          </h2>
          <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />
        </motion.div>
        {consults.map((service, index) => {
          const Icon = icons[index];

          return (
            <motion.div
              key={service.id}
              variants={slideLeft}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className={`
              border border-gray-400 my-4
              p-6 md:p-12
              shadow-sm
              relative bg-white

              ${index === 0 ? "md:max-w-[900px] md:mr-20" : ""}
              ${index === 1 ? "md:max-w-[900px] md:ml-24 md:-mt-10" : ""}
            `}
            >
              <h3 className="flex items-center gap-3 text-2xl md:text-3xl font-semibold mb-6 text-reddark font-[Crimson]">
                <Icon className="w-7 h-7 text-reddark shrink-0" />
                {service.title}
              </h3>

              <p className="text-gray-700 text-base md:text-lg mb-4">
                {service.description}
              </p>

              <ul className="space-y-3 text-gray-700 text-base md:text-lg">
                {service.list.map((item, i) => {
                  const hasColon = item.includes(":");

                  if (!hasColon) {
                    // 👉 Normal paragraph line (no bold)
                    return (
                      <li key={i} className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-reddark mt-1 shrink-0" />
                        <span>{item}</span>
                      </li>
                    );
                  }

                  // 👉 Bold title before ":"
                  const [title, ...rest] = item.split(":");
                  const description = rest.join(":");

                  return (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-reddark mt-1 shrink-0" />
                      <span>
                        <span className="font-semibold">{title}:</span>{" "}
                        {description.trim()}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default ListConsults;
